const share = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8.84 1v3.74C1.62 4.74 1 15 1 15s2.88-5.6 7.85-5.6v3.73L15 7.07z"/></svg>',
};

export { share as default };
